import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../../pages/Home";
import Categories from "../../pages/Courses/Categories";
import Legal from "../../pages/Legal";
import App from "../../App";
import Blog from "../../pages/Blog";
import NotFound from "../../pages/Not-Found";
import Courses from "../../pages/Courses";
import BlogDetails from "../../pages/Blog/details";
import CourseDetails from "../../pages/Courses/Details";
import Community from "../../pages/Community";
import CommunityCategory from "../../pages/Community/Categories";
import Services from "../../pages/Services";
import SignIn from "../../pages/auth/signin";
import Signup from "../../pages/auth/signup";

const AppRoutes = () => {
  return (
    <Router>
      <App>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:cat" element={<Categories />} />
          <Route path="/courses/:cat/:course" element={<CourseDetails />} />
          <Route path="/services" element={<Services />} />
          {/* <Route path="/services/:category" element={<ServiceCategory />} />
          <Route
            path="/services/:category/:serviceDetail"
            element={<ServiceDetails />} 
          />
            */}

          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/legal/:legalCat" element={<Legal />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/:cat" element={<CommunityCategory />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </App>
    </Router>
  );
};

export default AppRoutes;
